import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { ChevronDown } from "lucide-react";

const LANGS = [
  { code: "en", label: "EN", full: "English" },
  { code: "tr", label: "TR", full: "Türkçe" },
  { code: "id", label: "ID", full: "Bahasa Indonesia" },
];

const LanguageSwitcher = () => {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher-button"
        onClick={() => setOpen((s) => !s)}
        className="flex items-center gap-1.5 text-white/85 hover:text-[#D4AF37] text-[12px] uppercase tracking-[0.2em] font-semibold border border-white/15 hover:border-[#D4AF37]/60 px-3 py-2 rounded-sm transition-colors"
      >
        <span className="text-[#D4AF37]">{current.label}</span>
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 min-w-[180px] bg-[#0A1128] border border-white/10 rounded-sm shadow-2xl overflow-hidden">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`language-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`flex items-center justify-between w-full px-4 py-3 text-left text-[12px] uppercase tracking-[0.18em] transition-colors ${
                lang === l.code ? "text-[#D4AF37] bg-white/5" : "text-white/85 hover:bg-white/5 hover:text-[#D4AF37]"
              }`}
            >
              <span className="font-semibold">{l.label}</span>
              <span className="text-[10px] text-white/50 normal-case tracking-normal">{l.full}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
